import api from "@/services/api";
import { ENDPOINTS_FAUCET } from "@/services/endpoints";

export const requestFaucet = (address) =>
  api.post(ENDPOINTS_FAUCET.drip, { address }).then((r) => r.data);
